export default [

    {
        path: '',
        name: 'acoes-whatsapp',
        redirect: { name: 'acoes-whatsapp-home' },
    },

    {
        path: 'home',
        name: 'acoes-whatsapp-home',
        component: () => import('@/aplicacao/modulos/acoes-whatsapp/_Home'),
        meta: { autenticacao: true, permissao: 'ROLE_ACOES_WHATSAPP' },
    },

    {
        path: 'historico',
        name: 'acoes-whatsapp-historico',
        component: () => import('@/aplicacao/modulos/acoes-whatsapp/Historico'),
        meta: { autenticacao: true, permissao: 'ROLE_ACOES_WHATSAPP' },
    },

    {
        path: 'pendencias',
        name: 'acoes-whatsapp-pendencias',
        component: () => import('@/aplicacao/modulos/acoes-whatsapp/Pendencias'),
        meta: { autenticacao: true, permissao: 'ROLE_ACOES_WHATSAPP_PENDENCIAS' },
    },

    {
        path: 'rascunhos',
        name: 'acoes-whatsapp-rascunhos',
        component: () => import('@/aplicacao/modulos/acoes-whatsapp/Rascunhos'),
        meta: { autenticacao: true, permissao: 'ROLE_ACOES_WHATSAPP_SOLICITAR' },
    },

    {
        path: 'formulario/:id?',
        name: 'acoes-whatsapp-formulario',
        component: () => import('@/aplicacao/modulos/acoes-whatsapp/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE_ACOES_WHATSAPP_SOLICITAR' },
    },

    {
        path: ':id',
        name: 'acoes-whatsapp-fluxo',
        component: () => import('@/aplicacao/modulos/acoes-whatsapp/Fluxo'),
        meta: { autenticacao: true, permissao: 'ROLE_ACOES_WHATSAPP' },
    },

    {
        path: 'relatorios/geral',
        name: 'acoes-whatsapp-relatorios-geral',
        component: () => import('@/aplicacao/modulos/acoes-whatsapp/relatorios/Geral'),
        meta: { autenticacao: true, permissao: 'ROLE_ACOES_WHATSAPP_RELATORIO_GERAL' },
    },

]
